import moment from "moment";

export interface ITempTransactionsReport {
  status: string,
  subTotal: number,
  totalAmount: number | null,
  referenceNumber: string,
  createdAt: string,
  updatedAt: string,
  type: 'inequitable' | 'none inequitable',
  merchant: string | null,
  service: string | null,
  userRole : string | null,
  source : string | null ,
  phone : string | null ,
  receiver : string | null
}


export const dataTableFormatter = (object: ITempTransactionsReport) => {
  for (let [key, value] of Object.entries(object)) {
    if (value && (key == 'createdAt' || key == 'updatedAt'))
      value = moment(new Date(value)).format('MMMM Do YYYY, h:mm:ss a')
    if (!value) value = 'N/A';
    object[key] = value;
  }
  return object;
};
